/*
 * @Descripttion: 
 * @version: 
 * @Author: 付正生
 * @Date: 2022-06-20 17:43:51
 * @LastEditors: James chen
 * @LastEditTime: 2022-07-01 10:39:38
 */
export const tanRouter = [
  {
    path: '/proOrderDetail',
    name: 'proOrderDetail',
    component: () => import('@/views/planManage/proOrder/detail'),
    meta: { title: '生产订单详情', keepAlive: false }
  },
  {
    path: '/distribute',
    name: 'distribute',
    component: () => import('@/views/planManage/proOrder/distribute'),
    meta: { title: '派发至车间', keepAlive: false }
  },
  {
    path: '/workshopPlanDetail',
    name: 'workshopPlanDetail',
    component: () => import('@/views/planManage/workshopPlan/detail'),
    meta: { title: '计划详情', keepAlive: false }
  },
  {
    path: '/workshopPlanAdd',
    name: 'workshopPlanAdd',
    component: () => import('@/views/planManage/workshopPlan/add'),
    meta: { title: '手动排产', keepAlive: false }
  },
  {
    path: '/stockCheckForm',
    name: 'stockCheckForm',
    component: () => import('@/views/warehouseManagement/stockCheck/stockCheckForm'),
    meta: { title: '新建盘点单', keepAlive: false }
  },
]
